import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/blog`;

export const RSS_URL = `${process.env.REACT_APP_BACKEND_URL}/api/blog/rss.xml`;

export const fetchPosts = async () => (await axios.get(`${API}/posts`)).data;

export const fetchPost = async (slug) => (await axios.get(`${API}/posts/${slug}`)).data;

export const subscribe = async (email, source) =>
  (await axios.post(`${API}/subscribe`, { email, source })).data;

export const formatDate = (iso) =>
  new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "long", year: "numeric" }).format(
    new Date(iso)
  );
